export default __webpack_public_path__ + "static/favicon-c1390c677c4b3e958ce3a7a7921c9b42.png";